import { render, staticRenderFns } from "./BrandingPostcard.vue?vue&type=template&id=1eae24f6&scoped=true&"
import script from "./BrandingPostcard.vue?vue&type=script&lang=js&"
export * from "./BrandingPostcard.vue?vue&type=script&lang=js&"
import style0 from "./BrandingPostcard.vue?vue&type=style&index=0&id=1eae24f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eae24f6",
  null
  
)

export default component.exports